(function(){
	'use strict';

	var $scrollBtn = $('.smp-js-scroll-btn'),
	$smpBannerCarousel = $('.smp-banner-carousel');

	if($smpBannerCarousel.length){

		var bannerOffset = null;

		if($smpBannerCarousel.length){
			bannerOffset = ($smpBannerCarousel.offset().top + $smpBannerCarousel.outerHeight()) + 'px';
		}

		$smpBannerCarousel.each(function(){

			var $curBannerCarousel = $(this);

			$(this).find('.smp-banner-carousel__play-btn').click(function() {

				var $cur = $(this);

				if(!$cur.hasClass('active')){
					$cur.addClass('active');
					$curBannerCarousel.carousel('pause');
				}else {
					$cur.removeClass('active');
					$curBannerCarousel.carousel('cycle');
				}

				return false;
			});


		});
	}

}());
